<script setup>
import { computed } from 'vue'
import { useCartStore } from '../stores/cartStore'

const cartStore = useCartStore()

const stateFee = computed(() => {
  if (cartStore.products.length === 0) return undefined

  const product = cartStore.products.find((product) =>
    product.name.includes('State Filing Fee')
  )

  return product ? product : undefined
})

const stateFees = computed(() => {
  if (cartStore.products.length === 0) return []

  const products = cartStore.products.filter((product) =>
    product.name.includes('State Filing Fee')
  )

  return products
})

const ccProduct = computed(() => {
  if (cartStore.products.length === 0) return undefined
  return cartStore.products.filter(
    (product) => !product.name.includes('State Filing Fee')
  )[0]
})

const props = defineProps({
  anchorText: String
})

function trackAccordionClick() {
}
</script>
<template>
  <!-- Accordian -->
  <div
    class="accordion accordion-flush accordion-btn-icon-start mt-n1"
    id="accordionFlushExample"
  >
    <div class="accordion-item">
      <div class="accordion-header" id="flush-headingOne">
        <a
          @click="trackAccordionClick"
          class="accordion-button collapsed order-summary-accordion"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapseOne"
          aria-expanded="false"
          aria-controls="flush-collapseOne"
        >
          <small>{{ props.anchorText }}</small>
        </a>
      </div>
      <div
        id="flush-collapseOne"
        class="accordion-collapse collapse"
        aria-labelledby="flush-headingOne"
        data-bs-parent="#accordionFlushExample"
      >
        <div class="accordion-body">
          <!-- Product -->
          <div
            v-for="(fee, index) in stateFees"
            :key="fee.name"
            :class="[
              'border-top pt-4 mb-4',
              { '': index === 0 },
              {
                'border-bottom pb-4':
                  index === stateFees.length - 1 && ccProduct
              }
            ]"
          >
            <div class="d-flex">
              <div class="flex-shrink-0"></div>

              <div class="flex-grow-1">
                <dl class="row mb-0">
                  <dt class="col-7">{{ fee.name }}</dt>
                  <dd class="col-5 text-end mb-0">${{ fee.price / 100 }}</dd>
                </dl>
                <div class="mt-1">
                  <div class="text-body">
                    <span
                      class="small"
                      v-if="fee.description.includes('Late Fee')"
                      >The late fee collected by the State of Florida if filed
                      after 11:59 PM on May 1.</span
                    >
                    <span class="small" v-else
                      >The state filing fee collected by the State of
                      Florida.</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Product -->

          <!-- Product -->
          <div class="pb-4" v-if="ccProduct">
            <div class="d-flex">
              <div class="flex-shrink-0"></div>

              <div class="flex-grow-1">
                <dl class="row mb-0">
                  <dt class="col-8">{{ ccProduct.name }}</dt>
                  <dd class="col-4 text-end mb-0">
                    <del
                      >${{ ccProduct.price / 100 + 50
                      }}<span
                        class="small"
                        v-if="ccProduct.name.includes('ComplianceClerk Pro')"
                        >/yr</span
                      ></del
                    >
                    ${{ ccProduct.price / 100
                    }}<span
                      class="small"
                      v-if="ccProduct.name.includes('ComplianceClerk Pro')"
                      >/yr</span
                    >
                  </dd>
                </dl>
                <div class="mt-1">
                  <template
                    v-if="ccProduct.name.includes('ComplianceClerk Pro')"
                  >
                    <div class="text-body text-primary mb-3">
                      <span class="small"
                        >File today and save on your Beneficial Ownership Report
                        (a new Federal requirement from FinCEN).</span
                      >
                    </div>
                    <div class="px-auto small">
                      <ul class="list-checked list-checked-soft-bg-primary">
                        <li class="list-checked-item">
                          Annual Report <del>$99</del>
                          <span class="badge bg-soft-primary text-primary"
                            >Included!</span
                          >
                        </li>
                        <li class="list-checked-item">
                          Beneficial Ownership Report <del>$149</del>
                          <span class="badge bg-soft-primary text-primary"
                            >Included!</span
                          >
                        </li>
                        <li class="list-checked-item">
                          $250 in value for only ${{
                            ccProduct.price / 100
                          }}/yr!
                        </li>
                        <li class="list-checked-item">
                          Avoid Penalties and Never Miss a Filing
                        </li>
                        <li class="list-checked-item">
                          No Upsells or Hidden Fees
                        </li>
                      </ul>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-body">
                      <span class="small">{{ ccProduct.description }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- End Product -->
        </div>
      </div>
    </div>
  </div>
  <!-- End Accordian -->
</template>
